import React from 'react';

interface LoadingCardProps {
  type?: 'web' | 'action' | 'domain';
}

const LoadingCard: React.FC<LoadingCardProps> = ({ type = 'action' }) => (
  <div
    className={
      type === 'action'
        ? 'w-64 h-64 rounded-lg animate-pulse'
        : type === 'web'
        ? 'h-32 rounded-lg animate-pulse'
        : 'h-32 rounded-lg animate-pulse'
    }
    style={{ backgroundColor: 'var(--rhea-card-bg)' }}
  />
);

export default LoadingCard; 